import { SMBeamModel } from './types'

export interface ShearReinforcementSummary {
  aswMm2PerM: number   // Asw — shear reinforcement area per metre
  diameter: number     // stirrup bar diameter (mm)
  spacing: number      // stirrup spacing (mm)
  legs: number         // shear legs crossing the section
}

// Asw = π·Ø²/4 · legs · (1000/spacing) [mm²/m]. Uses the LAST rebar zone that has valid
// stirrups, mirroring the backend which overwrites checker.Asw per zone so the last one wins
// (BeamCodeCheckService.MaterialFactories) — so the panel shows the value actually checked.
export function summarizeShearReinforcement(model: SMBeamModel): ShearReinforcementSummary | null {
  const zones = model.rebarZones ?? []
  let chosen: { diameter: number; spacing: number; legs: number } | null = null
  for (const candidate of zones) {
    const stirrups = candidate.stirrups
    if (stirrups
      && Number.isFinite(stirrups.spacing) && stirrups.spacing > 0
      && Number.isFinite(stirrups.diameter) && stirrups.diameter > 0
      && Number.isFinite(stirrups.legs) && stirrups.legs > 0) {
      chosen = stirrups
    }
  }
  if (!chosen) {
    return null
  }
  const { diameter, spacing, legs } = chosen
  const aswMm2PerM = (Math.PI * diameter * diameter / 4) * legs * (1000 / spacing)
  return { aswMm2PerM, diameter, spacing, legs }
}
